import { render, staticRenderFns } from "./InlineBatchCard.vue?vue&type=template&id=2b7b8582&scoped=true"
import script from "./InlineBatchCard.vue?vue&type=script&lang=js"
export * from "./InlineBatchCard.vue?vue&type=script&lang=js"
import style0 from "./InlineBatchCard.vue?vue&type=style&index=0&id=2b7b8582&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b7b8582",
  null
  
)

export default component.exports